import throttle from 'lodash-es/throttle.js';

// Default browser root font-size, used until the real value is read on the next animation frame to avoid forcing a synchronous style recalculation during page load.
let remBase = 16;

const updateRemBase = () => {
	remBase = parseFloat(getComputedStyle(document.documentElement).fontSize);
	window.dispatchEvent(new Event('propel-rem-base-updated'));
};

requestAnimationFrame(updateRemBase);
window.addEventListener('resize', throttle(updateRemBase, 100));

const getRemBase = () => {
	return remBase;
};

export default getRemBase;
